module.exports = __webpack_public_path__ + "static/media/sidebar-bg-dark.596be11e.jpg";